const shop = {
  state: {
    channel: null,
    category: [],
    info: null,
    banner: null,
    cageTitle: [],
    currencyCode: null,
    extraTaxRate: 0,
    currencyDecimalPlace: 0
  },
  mutations: {
    SET_CHANNEL: (state, data) => {
      state.channel = data
    },
    SET_INFO: (state, data) => {
      state.info = data
    },
    SET_CATEGORY: (state, data) => {
      data.push({
        text: '全部分類',
        value: 0
      })
      state.category = data
    },
    SET_BANNER: (state, data) => {
      state.banner = data
    },
    SET_CAGETITLE: (state, data) => {
      state.cageTitle = data
    },
    SET_CURRENCY_CODE: (state, data) => {
      state.currencyCode = data
    },
    SET_EXTRA_TAX_RATE: (state, data) => {
      state.extraTaxRate = data
    },
    SET_CURRENCY_DECIMAL_PLACE: (state, data) => {
      state.currencyDecimalPlace = data
    },
  }
}
export default shop
